export const buildDriveDownloadUrl = (fileId) =>
  `https://drive.google.com/uc?export=download&id=${fileId}`

export const buildDriveViewUrl = (fileId) =>
  `https://drive.google.com/file/d/${fileId}/view`
